import { render, staticRenderFns } from "./FormulaDetection.vue?vue&type=template&id=b619f50c&scoped=true&"
import script from "./FormulaDetection.script.js?vue&type=script&lang=js&"
export * from "./FormulaDetection.script.js?vue&type=script&lang=js&"
import style0 from "./FormulaDetection.scss?vue&type=style&index=0&id=b619f50c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b619f50c",
  null
  
)

export default component.exports